<script setup lang="ts">
// 読み仮名自動入力フォーム
import type { AutoKana } from "vanilla-autokana";

interface Props {
  name?: string;
  kana?: string;
  required?: boolean;
  required_kana?: boolean;
}

const id_name = useUid();
const id_kana = useUid();

const props = withDefaults(defineProps<Props>(), {
  name: "",
  kana: "",
  required: false,
  required_kana: false,
});

const emit = defineEmits<{
  "update:name": [name: string];
  "update:kana": [kana: string];
}>();

// 氏名
const fullName = computed({
  get() {
    return props.name;
  },
  set(newValue) {
    emit("update:name", newValue);
  },
});

// 読み仮名
const furigana = computed({
  get() {
    return props.kana;
  },
  set(newValue) {
    emit("update:kana", newValue);
  },
});

// Autokana関連
let autokana: AutoKana;

onMounted(async () => {
  // ブラウザ実行時のみ必要なので、windowオブジェクト解決後インポートする
  if (process.client && id_name && id_kana) {
    const AutoKana = await import("vanilla-autokana");
    // 非同期のレンダリングが実行されてからAutokanaをバインドする
    await nextTick();
    autokana = AutoKana.bind(`#${id_name.value}`, `#${id_kana.value}`);
  }
});

// 漢字を入力するInputにふりがなのrefの値を紐付ける
function handleAutokana() {
  if (autokana) {
    furigana.value = autokana.getFurigana();
  }
}
</script>

<template>
  <FormInput
    v-model="fullName"
    label="お名前(フルネーム)"
    label2="例:ファミ庭 太郎"
    placeholder="氏名を入力"
    alert="名前をフルネームでご入力ください"
    :id="id_name"
    :required="required"
    @update:modelValue="handleAutokana"
  />
  <FormHiraganaInput
    v-model="furigana"
    label2="例:ふぁみてい たろう"
    :required="required_kana"
    :id="id_kana"
  />
</template>
